module.exports = __webpack_public_path__ + "static/media/image-bg-preview-storygame-pc.892d5098.png";